export const CodingAgent = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.75' y='0.75' width='46.5' height='46.5' rx='5.25' fill='#DDC9FF' />
      <rect
        x='0.75'
        y='0.75'
        width='46.5'
        height='46.5'
        rx='5.25'
        stroke='#D6BEFF'
        strokeWidth='1.5'
      />
      <path
        d='M33 13.9999H15C13.346 13.9999 12 15.3459 12 16.9999V33.9999H36V16.9999C36 15.3459 34.654 13.9999 33 13.9999ZM22.294 27.2909L20.88 28.7049L17.582 25.4059C16.807 24.6309 16.807 23.3689 17.582 22.5939L20.88 19.2959L22.294 20.7099L18.996 24.0079L22.294 27.2909ZM30.418 25.4069L27.119 28.7049L25.705 27.2909L29.004 23.9919L25.705 20.7089L27.119 19.2949L30.418 22.5929C30.794 22.9679 31.001 23.4679 31.001 23.9989C31.001 24.5299 30.794 25.0309 30.418 25.4069Z'
        fill='#3A2857'
      />
    </svg>
  )
}

export const TestingAgent = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.75' y='0.75' width='46.5' height='46.5' rx='5.25' fill='#DDC9FF' />
      <rect
        x='0.75'
        y='0.75'
        width='46.5'
        height='46.5'
        rx='5.25'
        stroke='#D6BEFF'
        strokeWidth='1.5'
      />
      <path
        d='M28.3496 26.7228L20.5376 34.5348C19.5936 35.4788 18.3386 35.9988 17.0026 35.9988C15.6666 35.9988 14.4116 35.4788 13.4676 34.5348C11.5186 32.5848 11.5186 29.4128 13.4676 27.4638L21.2796 19.6518L28.3506 26.7228H28.3496ZM26.7626 12.0388L25.3486 13.4528L26.4126 14.5168L22.6926 18.2368L29.7636 25.3078L33.4846 21.5868L34.5486 22.6508L35.9626 21.2368L26.7626 12.0388ZM34.8296 34.8278C35.5856 34.0728 36.0016 33.0678 36.0016 31.9998C36.0016 30.9318 35.5856 29.9268 34.8216 29.1638L32.0016 26.4048L29.1736 29.1718C28.4176 29.9268 28.0016 30.9318 28.0016 31.9998C28.0016 33.0678 28.4176 34.0728 29.1736 34.8278C29.9296 35.5838 30.9336 35.9998 32.0016 35.9998C33.0696 35.9998 34.0736 35.5838 34.8296 34.8278Z'
        fill='#3A2857'
      />
    </svg>
  )
}

export const DocumentationAgent = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.75' y='0.75' width='46.5' height='46.5' rx='5.25' fill='#DDC9FF' />
      <rect
        x='0.75'
        y='0.75'
        width='46.5'
        height='46.5'
        rx='5.25'
        stroke='#D6BEFF'
        strokeWidth='1.5'
      />
      <path
        d='M33.412 17H28.998V12.586L33.412 17ZM33.998 19V36H13.998V15C13.998 14.2044 14.3141 13.4413 14.8767 12.8787C15.4393 12.3161 16.2024 12 16.998 12H26.998V19H33.998ZM18.998 28H25.998V26H18.998V28ZM28.998 30H18.998V32H28.998V30ZM28.998 22H18.998V24H28.998V22Z'
        fill='#3A2857'
      />
    </svg>
  )
}

export const CodeReviewAgent = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.75' y='0.75' width='46.5' height='46.5' rx='5.25' fill='#DDC9FF' />
      <rect
        x='0.75'
        y='0.75'
        width='46.5'
        height='46.5'
        rx='5.25'
        stroke='#D6BEFF'
        strokeWidth='1.5'
      />
      <path
        d='M32.06 23.0989C31.523 22.0209 28.58 17.9999 24.001 17.9999C19.422 17.9999 16.478 22.0209 15.941 23.0979C15.654 23.6719 15.654 24.3299 15.941 24.9029C16.479 25.9799 19.423 29.9999 24 29.9999C28.577 29.9999 31.522 25.9789 32.06 24.9009C32.345 24.3289 32.345 23.6719 32.06 23.0989ZM24.001 26.4999C22.62 26.4999 21.501 25.3809 21.501 23.9999C21.501 22.6189 22.62 21.4999 24.001 21.4999C25.382 21.4999 26.501 22.6189 26.501 23.9999C26.501 25.3809 25.382 26.4999 24.001 26.4999ZM19.001 35.9999H15C13.346 35.9999 12 34.6539 12 32.9999V28.9999H14V32.9999C14 33.5509 14.449 33.9999 15 33.9999H19L19.001 35.9999ZM33.001 35.9999H29.001V33.9999H33.001C33.552 33.9999 34.001 33.5509 34.001 32.9999V28.9999H36.001V32.9999C36.001 34.6539 34.655 35.9999 33.001 35.9999ZM36.001 18.9999H34.001V14.9999C34.001 14.4489 33.552 13.9999 33.001 13.9999H29.001V11.9999H33.001C34.655 11.9999 36.001 13.3459 36.001 14.9999V18.9999ZM14 18.9999H12V14.9999C12 13.3459 13.346 11.9999 15 11.9999H19V13.9999H15C14.449 13.9999 14 14.4489 14 14.9999V18.9999Z'
        fill='#3A2857'
      />
    </svg>
  )
}

export const MigrationAgent = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.75' y='0.75' width='46.5' height='46.5' rx='5.25' fill='#DDC9FF' />
      <rect
        x='0.75'
        y='0.75'
        width='46.5'
        height='46.5'
        rx='5.25'
        stroke='#D6BEFF'
        strokeWidth='1.5'
      />
      <path
        d='M29.974 19.1462C29.643 19.0802 29.372 18.8732 29.232 18.5772C27.682 15.3062 24.089 13.4772 20.498 14.1392C17.226 14.7392 14.661 17.3512 14.114 20.6402C13.952 21.6112 13.964 22.5832 14.147 23.5302C14.207 23.8392 14.074 24.1832 13.801 24.4312C12.656 25.4722 12 26.9552 12 28.5012C12 31.5332 14.467 34.0012 17.5 34.0012H28.5C32.636 34.0012 36 30.6372 36 26.5012C36 22.9362 33.466 19.8422 29.974 19.1462ZM27.121 25.7082C26.926 25.9032 26.67 26.0012 26.414 26.0012C26.158 26.0012 25.902 25.9032 25.707 25.7082L24 24.0012V29.0012C24 29.5542 23.552 30.0012 23 30.0012C22.448 30.0012 22 29.5542 22 29.0012V24.0012L20.293 25.7082C19.902 26.0992 19.27 26.0992 18.879 25.7082C18.488 25.3172 18.488 24.6852 18.879 24.2942L21.586 21.5872C21.972 21.2012 22.479 21.0072 22.986 21.0042L23 21.0012L23.014 21.0042C23.522 21.0072 24.028 21.2012 24.414 21.5872L27.121 24.2942C27.512 24.6852 27.512 25.3172 27.121 25.7082Z'
        fill='#3A2857'
      />
    </svg>
  )
}

export const SecurityIcon = () => {
  return (
    <svg
      width='245'
      height='153'
      viewBox='0 0 245 153'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2245_1872)'>
        <rect width='245' height='153' fill='#C8A7FF' />
        <path
          d='M122 217.601C121.08 217.601 120.11 217.517 119.089 217.348C118.068 217.179 117.121 216.925 116.249 216.587C96.2811 208.98 80.4143 196.078 68.6486 177.882C56.8829 159.686 51 139.988 51 118.79V75.3477C51 71.8992 51.9974 68.7785 53.9921 65.9859C55.9869 63.1932 58.5395 61.1646 61.65 59.9002L116.269 39.6144C118.244 38.8977 120.154 38.5393 122 38.5393C123.846 38.5393 125.76 38.8977 127.741 39.6144L182.35 59.9002C185.46 61.1646 188.013 63.1932 190.008 65.9859C192.003 68.7785 193 71.8992 193 75.3477V118.79C193 139.988 187.117 159.686 175.351 177.882C163.586 196.078 147.719 208.98 127.751 216.587C126.872 216.925 125.925 217.179 124.911 217.348C123.897 217.517 122.926 217.601 122 217.601Z'
          fill='#09080A'
        />
        <path
          d='M116.33 216.379L116.328 216.378C96.4056 208.788 80.5764 195.918 68.8361 177.761C57.0932 159.6 51.2233 139.944 51.2233 118.79V75.3477C51.2233 71.9455 52.2063 68.8703 54.1738 66.1157C56.1439 63.3575 58.662 61.3566 61.7309 60.1083C61.732 60.1079 61.733 60.1074 61.7341 60.107L116.345 39.8243C116.346 39.8242 116.346 39.8241 116.346 39.824C118.299 39.1151 120.184 38.7626 122 38.7626C123.816 38.7626 125.704 39.1151 127.664 39.8241C127.664 39.8242 127.665 39.8243 127.665 39.8244L182.266 60.107C182.267 60.1074 182.268 60.1078 182.269 60.1083C185.338 61.3565 187.856 63.3575 189.826 66.1157C191.794 68.8703 192.777 71.9455 192.777 75.3477V118.79C192.777 139.944 186.907 159.6 175.164 177.761C163.424 195.918 147.594 208.788 127.672 216.378L127.671 216.379C126.807 216.711 125.875 216.961 124.874 217.128C123.871 217.295 122.913 217.378 122 217.378C121.094 217.378 120.136 217.295 119.125 217.127C118.118 216.961 117.186 216.711 116.33 216.379Z'
          stroke='white'
          strokeOpacity='0.1'
          strokeWidth='0.446541'
        />
        <path
          d='M122 217.601C121.08 217.601 120.11 217.517 119.089 217.348C118.068 217.179 117.121 216.925 116.249 216.587C96.2811 208.98 80.4143 196.078 68.6486 177.882C56.8829 159.686 51 139.988 51 118.79V75.3477C51 71.8992 51.9974 68.7785 53.9921 65.9859C55.9869 63.1932 58.5395 61.1646 61.65 59.9002L116.269 39.6144C118.244 38.8977 120.154 38.5393 122 38.5393C123.846 38.5393 125.76 38.8977 127.741 39.6144L182.35 59.9002C185.46 61.1646 188.013 63.1932 190.008 65.9859C192.003 68.7785 193 71.8992 193 75.3477V118.79C193 139.988 187.117 159.686 175.351 177.882C163.586 196.078 147.719 208.98 127.751 216.587C126.872 216.925 125.925 217.179 124.911 217.348C123.897 217.517 122.926 217.601 122 217.601Z'
          fill='#3A2857'
        />
        <path
          d='M100.942 92.3391C99.834 92.3391 98.8767 92.1438 98.0705 91.7534C97.2643 91.3629 96.6282 90.8212 96.1622 90.1284C95.7087 89.423 95.4442 88.6043 95.3686 87.6721L97.8627 87.521C97.9383 88.1004 98.102 88.5917 98.3539 88.9948C98.6185 89.3978 98.9649 89.7065 99.3931 89.9206C99.834 90.1221 100.363 90.2229 100.98 90.2229C101.509 90.2229 101.956 90.1599 102.322 90.034C102.7 89.8954 102.983 89.7002 103.172 89.4482C103.374 89.1837 103.474 88.8625 103.474 88.4846C103.474 88.1445 103.392 87.8422 103.229 87.5777C103.065 87.3005 102.75 87.0549 102.284 86.8408C101.818 86.614 101.125 86.3936 100.206 86.1795C99.0971 85.9275 98.2091 85.6441 97.5415 85.3292C96.8739 85.0017 96.3889 84.5986 96.0866 84.12C95.7843 83.6287 95.6331 83.0178 95.6331 82.2872C95.6331 81.5062 95.8284 80.8197 96.2188 80.2277C96.6093 79.6231 97.1636 79.157 97.8816 78.8295C98.5996 78.4894 99.4624 78.3194 100.47 78.3194C101.541 78.3194 102.448 78.5146 103.191 78.9051C103.934 79.283 104.52 79.8057 104.948 80.4733C105.376 81.1409 105.641 81.9093 105.742 82.7785L103.267 82.8918C103.204 82.4006 103.052 81.9723 102.813 81.607C102.586 81.2417 102.271 80.9583 101.868 80.7568C101.478 80.5426 100.999 80.4355 100.432 80.4355C99.7269 80.4355 99.1664 80.5993 98.7507 80.9268C98.3476 81.2417 98.1461 81.6637 98.1461 82.1927C98.1461 82.558 98.228 82.8603 98.3917 83.0997C98.5681 83.339 98.8767 83.5468 99.3175 83.7232C99.7584 83.8869 100.376 84.0633 101.169 84.2522C102.366 84.5042 103.317 84.8254 104.022 85.2159C104.728 85.6063 105.232 86.0598 105.534 86.5763C105.836 87.0927 105.987 87.6847 105.987 88.3523C105.987 89.1711 105.779 89.8828 105.364 90.4874C104.948 91.0795 104.362 91.5392 103.607 91.8667C102.851 92.1816 101.963 92.3391 100.942 92.3391ZM113.431 92.3391C112.109 92.3391 110.969 92.062 110.011 91.5077C109.054 90.9409 108.317 90.1347 107.801 89.0892C107.297 88.0437 107.045 86.7967 107.045 85.3481C107.045 83.8995 107.297 82.6525 107.801 81.607C108.317 80.5489 109.054 79.7364 110.011 79.1696C110.969 78.6028 112.109 78.3194 113.431 78.3194C114.779 78.3194 115.925 78.6028 116.87 79.1696C117.827 79.7364 118.558 80.5489 119.062 81.607C119.578 82.6525 119.836 83.8995 119.836 85.3481C119.836 86.7967 119.578 88.0437 119.062 89.0892C118.558 90.1347 117.827 90.9409 116.87 91.5077C115.925 92.062 114.779 92.3391 113.431 92.3391ZM113.431 90.204C114.25 90.204 114.943 90.0151 115.51 89.6372C116.089 89.2467 116.53 88.6924 116.832 87.9745C117.147 87.2439 117.305 86.3684 117.305 85.3481C117.305 84.3278 117.147 83.4524 116.832 82.7218C116.53 81.9912 116.089 81.4307 115.51 81.0402C114.943 80.6497 114.25 80.4544 113.431 80.4544C112.638 80.4544 111.951 80.6497 111.372 81.0402C110.792 81.4307 110.345 81.9912 110.03 82.7218C109.728 83.4524 109.577 84.3278 109.577 85.3481C109.577 86.3684 109.728 87.2439 110.03 87.9745C110.345 88.6924 110.792 89.2467 111.372 89.6372C111.951 90.0151 112.638 90.204 113.431 90.204ZM126.916 92.3391C125.694 92.3391 124.617 92.062 123.685 91.5077C122.753 90.9409 122.022 90.141 121.493 89.1081C120.964 88.0626 120.7 86.8093 120.7 85.3481C120.7 83.9121 120.958 82.6714 121.474 81.6259C121.991 80.5678 122.715 79.7553 123.647 79.1885C124.579 78.6091 125.675 78.3194 126.935 78.3194C128.648 78.3194 129.977 78.7476 130.922 79.6042C131.866 80.4481 132.484 81.6322 132.773 83.1564L130.204 83.2886C130.04 82.4069 129.687 81.7141 129.146 81.2102C128.604 80.7064 127.867 80.4544 126.935 80.4544C126.179 80.4544 125.524 80.656 124.97 81.0591C124.416 81.4621 123.987 82.029 123.685 82.7596C123.383 83.4902 123.232 84.353 123.232 85.3481C123.232 86.3558 123.383 87.225 123.685 87.9556C124 88.6736 124.435 89.2278 124.989 89.6183C125.543 90.0088 126.185 90.204 126.916 90.204C127.911 90.204 128.68 89.9332 129.221 89.3915C129.775 88.8373 130.128 88.0815 130.279 87.1242L132.849 87.2565C132.673 88.302 132.333 89.2089 131.829 89.9773C131.325 90.7331 130.657 91.3188 129.826 91.7345C129.007 92.1375 128.037 92.3391 126.916 92.3391ZM137.629 92.0368C137.629 90.9535 137.78 90.0088 138.082 89.2026C138.384 88.3838 138.894 87.6407 139.612 86.973C140.33 86.2928 141.3 85.6315 142.522 84.9891C143.127 84.6616 143.612 84.3719 143.977 84.12C144.342 83.868 144.607 83.6098 144.771 83.3453C144.934 83.0682 145.016 82.7407 145.016 82.3628C145.016 81.9849 144.934 81.6574 144.771 81.3803C144.607 81.0906 144.361 80.8638 144.034 80.7001C143.719 80.5363 143.322 80.4544 142.843 80.4544C142.075 80.4544 141.464 80.6749 141.011 81.1157C140.57 81.544 140.299 82.1612 140.198 82.9674L137.666 82.8163C137.792 81.4181 138.302 80.3222 139.197 79.5286C140.104 78.7224 141.319 78.3194 142.843 78.3194C143.826 78.3194 144.67 78.4894 145.375 78.8295C146.081 79.157 146.616 79.6231 146.981 80.2277C147.359 80.8323 147.548 81.5314 147.548 82.325C147.548 83.0052 147.428 83.5909 147.189 84.0822C146.962 84.5734 146.585 85.0269 146.055 85.4426C145.539 85.8457 144.84 86.2802 143.958 86.7463C142.85 87.3383 142.018 87.9115 141.464 88.4657C140.91 89.0074 140.614 89.486 140.576 89.9017H147.548V92.0368H137.629Z'
          fill='white'
        />
        <path
          d='M95.1562 111.264V99.9843H91.075V97.8492H101.675V99.9843H97.6125V111.264H95.1562ZM106.432 111.264V105.974L101.746 97.8492H104.505L107.679 103.555L110.834 97.8492H113.593L108.907 105.974V111.264H106.432ZM114.42 111.264V97.8492H119.616C121.19 97.8492 122.418 98.2271 123.3 98.9829C124.182 99.7387 124.623 100.784 124.623 102.119C124.623 103.014 124.421 103.788 124.018 104.443C123.615 105.086 123.042 105.577 122.299 105.917C121.555 106.257 120.661 106.427 119.616 106.427H116.876V111.264H114.42ZM116.876 104.292H119.502C120.334 104.292 120.97 104.11 121.411 103.744C121.864 103.379 122.091 102.837 122.091 102.119C122.091 101.414 121.864 100.885 121.411 100.532C120.97 100.167 120.334 99.9843 119.502 99.9843H116.876V104.292ZM126.409 111.264V97.8492H135.44V99.9843H128.865V103.48H135.214V105.596H128.865V109.129H135.592V111.264H126.409ZM141.724 111.264C141.724 110.181 141.875 109.236 142.177 108.43C142.48 107.611 142.99 106.868 143.708 106.201C144.426 105.52 145.396 104.859 146.618 104.217C147.222 103.889 147.707 103.599 148.073 103.348C148.438 103.096 148.702 102.837 148.866 102.573C149.03 102.296 149.112 101.968 149.112 101.59C149.112 101.212 149.03 100.885 148.866 100.608C148.702 100.318 148.457 100.091 148.129 99.9276C147.814 99.7639 147.418 99.682 146.939 99.682C146.17 99.682 145.56 99.9024 145.106 100.343C144.665 100.772 144.394 101.389 144.294 102.195L141.762 102.044C141.888 100.646 142.398 99.5497 143.292 98.7561C144.199 97.95 145.415 97.5469 146.939 97.5469C147.921 97.5469 148.765 97.7169 149.471 98.057C150.176 98.3846 150.711 98.8506 151.077 99.4552C151.455 100.06 151.644 100.759 151.644 101.553C151.644 102.233 151.524 102.818 151.285 103.31C151.058 103.801 150.68 104.254 150.151 104.67C149.634 105.073 148.935 105.508 148.054 105.974C146.945 106.566 146.114 107.139 145.56 107.693C145.005 108.235 144.709 108.714 144.672 109.129H151.644V111.264H141.724Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_2245_1872'>
          <rect width='245' height='153' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const UsecasesIcon = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='48' height='48' rx='6' fill='white' />
      <rect
        x='0.428571'
        y='0.428571'
        width='47.1429'
        height='47.1429'
        rx='5.57143'
        stroke='black'
        strokeOpacity='0.1'
        strokeWidth='0.857143'
      />
      <path
        d='M14.3902 30.0983L22.6151 15.8917C23.0696 15.1065 23.2969 14.714 23.5935 14.5821C23.8521 14.4671 24.1474 14.4671 24.4061 14.5821C24.7026 14.714 24.9299 15.1065 25.3844 15.8917L33.6093 30.0983C34.0655 30.8863 34.2936 31.2803 34.2599 31.6037C34.2305 31.8857 34.0827 32.142 33.8534 32.3088C33.5904 32.5 33.1352 32.5 32.2246 32.5H15.7749C14.8643 32.5 14.4091 32.5 14.1461 32.3088C13.9168 32.142 13.769 31.8857 13.7396 31.6037C13.7059 31.2803 13.934 30.8863 14.3902 30.0983Z'
        stroke='#3A2857'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const BlogIcon = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='48' height='48' rx='6' fill='white' />
      <rect
        x='0.428571'
        y='0.428571'
        width='47.1429'
        height='47.1429'
        rx='5.57143'
        stroke='black'
        strokeOpacity='0.1'
        strokeWidth='0.857143'
      />
      <path
        d='M32 31V28H19C17.3431 28 16 29.3431 16 31M20.8 34H28.8C29.9201 34 30.4802 34 30.908 33.782C31.2843 33.5903 31.5903 33.2843 31.782 32.908C32 32.4802 32 31.9201 32 30.8V17.2C32 16.0799 32 15.5198 31.782 15.092C31.5903 14.7157 31.2843 14.4097 30.908 14.218C30.4802 14 29.9201 14 28.8 14H20.8C19.1198 14 18.2798 14 17.638 14.327C17.0735 14.6146 16.6146 15.0735 16.327 15.638C16 16.2798 16 17.1198 16 18.8V29.2C16 30.8802 16 31.7202 16.327 32.362C16.6146 32.9265 17.0735 33.3854 17.638 33.673C18.2798 34 19.1198 34 20.8 34Z'
        stroke='#3A2857'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const ResourcesLibraryIcon = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='48' height='48' rx='6' fill='white' />
      <rect
        x='0.428571'
        y='0.428571'
        width='47.1429'
        height='47.1429'
        rx='5.57143'
        stroke='black'
        strokeOpacity='0.1'
        strokeWidth='0.857143'
      />
      <path
        d='M24 21.25H15M24 16L15 16M33 26.75H15M33 32H15M31.72 14.96L27.8533 17.86C27.5638 18.0771 27.4191 18.1857 27.3673 18.3188C27.322 18.4353 27.322 18.5647 27.3673 18.6812C27.4191 18.8143 27.5638 18.9229 27.8533 19.14L31.72 22.04C32.132 22.349 32.338 22.5035 32.5104 22.4999C32.6604 22.4968 32.8012 22.4264 32.8937 22.3083C33 22.1725 33 21.915 33 21.4V15.6C33 15.085 33 14.8276 32.8937 14.6918C32.8012 14.5736 32.6604 14.5032 32.5104 14.5001C32.338 14.4965 32.132 14.651 31.72 14.96Z'
        stroke='#3A2857'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const MuleSoftIntegrityIcon = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='48' height='48' rx='6' fill='white' />
      <rect
        x='0.428571'
        y='0.428571'
        width='47.1429'
        height='47.1429'
        rx='5.57143'
        stroke='black'
        strokeOpacity='0.1'
        strokeWidth='0.857143'
      />
      <path
        d='M26 14.2695V18.4001C26 18.9601 26 19.2401 26.109 19.4541C26.2049 19.6422 26.3578 19.7952 26.546 19.8911C26.7599 20.0001 27.0399 20.0001 27.6 20.0001H31.7305M26 29.5L28.5 27L26 24.5M22 24.5L19.5 27L22 29.5M32 21.9882V29.2C32 30.8802 32 31.7202 31.673 32.362C31.3854 32.9265 30.9265 33.3854 30.362 33.673C29.7202 34 28.8802 34 27.2 34H20.8C19.1198 34 18.2798 34 17.638 33.673C17.0735 33.3854 16.6146 32.9265 16.327 32.362C16 31.7202 16 30.8802 16 29.2V18.8C16 17.1198 16 16.2798 16.327 15.638C16.6146 15.0735 17.0735 14.6146 17.638 14.327C18.2798 14 19.1198 14 20.8 14H24.0118C24.7455 14 25.1124 14 25.4577 14.0829C25.7638 14.1564 26.0564 14.2776 26.3249 14.4421C26.6276 14.6276 26.887 14.887 27.4059 15.4059L30.5941 18.5941C31.113 19.113 31.3724 19.3724 31.5579 19.6751C31.7224 19.9436 31.8436 20.2362 31.9171 20.5423C32 20.8876 32 21.2545 32 21.9882Z'
        stroke='#3A2857'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const AboutUsIcon = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='48' height='48' rx='6' fill='white' />
      <rect
        x='0.428571'
        y='0.428571'
        width='47.1429'
        height='47.1429'
        rx='5.57143'
        stroke='black'
        strokeOpacity='0.1'
        strokeWidth='0.857143'
      />
      <path
        d='M23 23H18.2C17.0799 23 16.5198 23 16.092 23.218C15.7157 23.4097 15.4097 23.7157 15.218 24.092C15 24.5198 15 25.0799 15 26.2V33M33 33V18.2C33 17.0799 33 16.5198 32.782 16.092C32.5903 15.7157 32.2843 15.4097 31.908 15.218C31.4802 15 30.9201 15 29.8 15H26.2C25.0799 15 24.5198 15 24.092 15.218C23.7157 15.4097 23.4097 15.7157 23.218 16.092C23 16.5198 23 17.0799 23 18.2V33M34 33H14M26.5 19H29.5M26.5 23H29.5M26.5 27H29.5'
        stroke='#3A2857'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const CareersIcon = () => {
  return (
    <svg width='49' height='48' viewBox='0 0 49 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.333984' width='48' height='48' rx='6' fill='white' />
      <rect
        x='0.762556'
        y='0.428571'
        width='47.1429'
        height='47.1429'
        rx='5.57143'
        stroke='black'
        strokeOpacity='0.1'
        strokeWidth='0.857143'
      />
      <path
        d='M34 33V31C34 29.1362 32.7252 27.5701 31 27.126M27.5 15.2908C28.9659 15.8841 30 17.3213 30 19C30 20.6787 28.9659 22.1159 27.5 22.7092M29 33C29 31.1362 29 30.2044 28.6955 29.4693C28.2895 28.4892 27.5108 27.7105 26.5307 27.3045C25.7956 27 24.8638 27 23 27H20C18.1362 27 17.2044 27 16.4693 27.3045C15.4892 27.7105 14.7105 28.4892 14.3045 29.4693C14 30.2044 14 31.1362 14 33M25.5 19C25.5 21.2091 23.7091 23 21.5 23C19.2909 23 17.5 21.2091 17.5 19C17.5 16.7909 19.2909 15 21.5 15C23.7091 15 25.5 16.7909 25.5 19Z'
        stroke='#3A2857'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const ContactIcon = () => {
  return (
    <svg width='49' height='48' viewBox='0 0 49 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.666016' width='48' height='48' rx='6' fill='white' />
      <rect
        x='1.09459'
        y='0.428571'
        width='47.1429'
        height='47.1429'
        rx='5.57143'
        stroke='black'
        strokeOpacity='0.1'
        strokeWidth='0.857143'
      />
      <path
        d='M26.744 14.6336L34.272 19.5268C34.538 19.6997 34.671 19.7861 34.7674 19.9015C34.8527 20.0035 34.9167 20.1216 34.9558 20.2488C35 20.3924 35 20.551 35 20.8683V28.2C35 29.8802 35 30.7202 34.673 31.362C34.3854 31.9265 33.9265 32.3854 33.362 32.673C32.7202 33 31.8802 33 30.2 33H19.8C18.1198 33 17.2798 33 16.638 32.673C16.0735 32.3854 15.6146 31.9265 15.327 31.362C15 30.7202 15 29.8802 15 28.2V20.8683C15 20.551 15 20.3924 15.0442 20.2488C15.0833 20.1216 15.1473 20.0035 15.2326 19.9015C15.329 19.7861 15.462 19.6997 15.728 19.5268L23.256 14.6336M26.744 14.6336C26.1127 14.2233 25.7971 14.0181 25.457 13.9383C25.1564 13.8677 24.8436 13.8677 24.543 13.9383C24.2029 14.0181 23.8873 14.2233 23.256 14.6336M26.744 14.6336L32.9361 18.6585C33.624 19.1056 33.9679 19.3291 34.087 19.6126C34.1911 19.8604 34.1911 20.1396 34.087 20.3874C33.9679 20.6709 33.624 20.8944 32.9361 21.3415L26.744 25.3664C26.1127 25.7767 25.7971 25.9819 25.457 26.0617C25.1564 26.1323 24.8436 26.1323 24.543 26.0617C24.2029 25.9819 23.8873 25.7767 23.256 25.3664L17.0639 21.3415C16.376 20.8944 16.0321 20.6709 15.913 20.3874C15.8089 20.1396 15.8089 19.8604 15.913 19.6126C16.0321 19.3291 16.376 19.1056 17.0639 18.6585L23.256 14.6336M34.5 31L27.8572 25M22.1428 25L15.5 31'
        stroke='#3A2857'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
